module.exports = __webpack_public_path__ + "images/mobile/home_company-409bf97236c0379508a5e5fcab7db2d1.png";